var render = function render(_c, _vm) {
  return _c(
    "wa-question-and-answer",
    {
      attrs: {
        id: "what-creators-may-not-do",
        title: "What Creators May Not Do",
      },
    },
    [
      _c("template", { slot: "copy" }, [
        _c("h4", { staticClass: "h5 margin-top-2xl" }, [
          _vm._v("Distribute to Non-Creators"),
        ]),
        _vm._v(" "),
        _c("p", [
          _c("em", [_vm._v("Creators")]),
          _vm._v(
            "\n      may not make, share, or publish standalone copies of\n      "
          ),
          _c("em", [_vm._v("Pro Icons")]),
          _vm._v("\n      or\n      "),
          _c("em", [_vm._v("Pro Software")]),
          _vm._v("\n      for\n      "),
          _c("em", [_vm._v("non-Creators")]),
          _vm._v(
            ". For the purpose of clarity (and not for limitation), the use of Pro Icons or Pro Icons Software must constitute a new or separate\n      work. Making, sharing, or publishing copies of Pro Icons or Pro Software in a non-transformative way or in a manner where the Pro Icons or Pro Software\n      are the primary part of what is being made, shared, or published is expressly prohibited.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("h4", { staticClass: "h5 margin-top-2xl" }, [
          _vm._v("Pass on Permission to Make Changes"),
        ]),
        _vm._v(" "),
        _c("p", [
          _c("em", [_vm._v("Creators")]),
          _vm._v("\n      may not give\n      "),
          _c("em", [_vm._v("non-Creators")]),
          _vm._v("\n      permission to make changes to\n      "),
          _c("em", [_vm._v("Pro Icons")]),
          _vm._v("\n      or\n      "),
          _c("em", [_vm._v("Projects")]),
          _vm._v("\n      that\n      "),
          _c("em", [_vm._v("Embed Pro Icons")]),
          _vm._v(".\n    "),
        ]),
        _vm._v(" "),
        _c("h4", { staticClass: "h5 margin-top-2xl" }, [
          _vm._v("Pass on Permission to Embed"),
        ]),
        _vm._v(" "),
        _c("p", [
          _c("em", [_vm._v("Creators")]),
          _vm._v("\n      may not give\n      "),
          _c("em", [_vm._v("non-Creators")]),
          _vm._v("\n      permission to\n      "),
          _c("em", [_vm._v("Embed Pro Icons")]),
          _vm._v("\n      in new\n      "),
          _c("em", [_vm._v("Projects")]),
          _vm._v("\n      of their own, or to\n      "),
          _c("em", [_vm._v("Embed")]),
          _vm._v("\n      them in\n      "),
          _c("em", [_vm._v("Projects")]),
          _vm._v(
            "\n      in new ways. Similarly, Creators may not give non-Creators permission to use Pro Icons or Projects that embed Pro Icons for further use or resale.\n    "
          ),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }